var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.184 2.4H19.2C20.52 2.4 21.6 3.48 21.6 4.8V21.6C21.6 22.92 20.52 24 19.2 24H2.4C2.232 24 2.076 23.988 1.92 23.964C1.452 23.868 1.032 23.628 0.708 23.304C0.492 23.076 0.312 22.824 0.192 22.536C0.072 22.248 0 21.924 0 21.6V4.8C0 4.464 0.072 4.152 0.192 3.876C0.312 3.588 0.492 3.324 0.708 3.108C1.032 2.784 1.452 2.544 1.92 2.448C2.076 2.412 2.232 2.4 2.4 2.4H7.416C7.92 1.008 9.24 0 10.8 0C12.36 0 13.68 1.008 14.184 2.4ZM4.8 7.2H16.8V9.6H4.8V7.2ZM16.8 12H4.8V14.4H16.8V12ZM13.2 16.8H4.8V19.2H13.2V16.8ZM10.8 2.1C11.292 2.1 11.7 2.508 11.7 3C11.7 3.492 11.292 3.9 10.8 3.9C10.308 3.9 9.9 3.492 9.9 3C9.9 2.508 10.308 2.1 10.8 2.1ZM2.4 21.6H19.2V4.8H2.4V21.6Z",
    fill: "#292F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.340d16525401884c4aca3a6356e7406e.svg";
export { ForwardRef as ReactComponent };